import React from 'react';
import { Link } from 'react-router-dom';
import './LegalPage.css';

const TermsPage: React.FC = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>Terms of Service</h1>
        <p className="last-updated">Last Updated: July 28, 2026</p>

        <section>
          <h2>1. Overview</h2>
          <p>
            By placing an order on micahlynise.com, you agree to these terms. Please read them before purchasing.
          </p>
        </section>

        <section>
          <h2>2. Products</h2>
          <p>
            All products are handmade in small batches. Colors, textures, and scent profiles may vary slightly
            between batches. This is normal and reflects the handcrafted nature of our products.
          </p>
          <p>
            Product images are representative. Slight variations in color may occur due to screen settings.
          </p>
        </section>

        <section>
          <h2>3. Orders & Payment</h2>
          <ul>
            <li>All prices are in USD.</li>
            <li>Payment is processed securely through Stripe.</li>
            <li>We reserve the right to cancel orders due to pricing errors or inventory issues. You will be fully refunded.</li>
            <li>You will receive an email confirmation when your order is placed and when it ships.</li>
          </ul>
        </section>

        <section>
          <h2>4. Shipping</h2>
          <p>
            We ship within the United States only. See our <Link to="/policies/shipping">Shipping Policy</Link> for
            rates and delivery times.
          </p>
        </section>

        <section>
          <h2>5. Returns</h2>
          <p>
            Returns are accepted within 14 days with prior approval. Blind returns are not accepted.
            See our <Link to="/policies/returns">Returns Policy</Link> for details.
          </p>
        </section>

        <section>
          <h2>6. Intellectual Property</h2>
          <p>
            All artwork, photographs, music, and content on this site are the property of Micah Lynise and may not
            be reproduced, distributed, or used without written permission.
          </p>
        </section>

        <section>
          <h2>7. Limitation of Liability</h2>
          <p>
            Micah Lynise is not liable for any indirect, incidental, or consequential damages arising from the use
            of this site or purchase of products. Our total liability is limited to the amount you paid for your order.
          </p>
        </section>

        <section>
          <h2>8. Contact</h2>
          <p>
            Questions about these terms? Please contact me at <a href="mailto:hello@micahlynise.com">hello@micahlynise.com</a>.
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsPage;
